<template>
  <div class="wrap">
    <g-header :navActive="0"></g-header>
    <div class="swiper-container">
      <swiper :options="swiperOption" ref="mySwiper" v-if="bannerShow">
        <!-- slides -->
        <div class="swiper-slide" ref="swiperSlide">
          <img src="./imgs/banner1.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="./imgs/banner2.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="./imgs/banner3.jpg" />
        </div>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="block-1">
      <div class="g-block-title">
        <p class="name">平台介绍</p>
        <p class="line"></p>
        <p class="en-name">PLATFORM INTRODUCTION</p>
      </div>
      <p
        class="block-text"
      >新华网循证医保鉴证核查平台，是以规范两定机构及参保人的药械销售与使用行为为目标，以药械追溯码（类似产品的身份证）为信息载体，将药械的鉴证核查嵌入到医保服务与支付的各种销售与使用的场景中，做到既可以提升医保服务能力，又可以降低医保基金支付风险，推动医保服务管理创新发展。</p>
      <img class="bg" src="./imgs/bg-1.png" />
    </div>
    <div class="block-2">
      <div class="g-block-title light">
        <p class="name">平台资源</p>
        <p class="line"></p>
        <p class="en-name">PLATFORM RESOURCES</p>
      </div>
      <div class="block-2-list">
        <div class="box">
          <div class="circle">
            {{block2Num}}
            <span>+</span>
          </div>
          <div class="text">已对接第三方追溯平台或制药企业自建平台</div>
        </div>
        <div class="box">
          <div
            class="circle"
            :style="{transform: block2Num>=1000?'rotate(0deg)':'rotate(180deg)'}"
          >
            <span class="small-circle">
              <img src="./imgs/2-1.png" />
            </span>
            <span class="small-circle">
              <img src="./imgs/2-2.png" />
            </span>
            <span class="small-circle">
              <img src="./imgs/2-3.png" />
            </span>
          </div>
          <div class="text">药监、医保和卫健系统三大体系药械目录精准映射</div>
        </div>
        <div class="box">
          <div class="circle">
            <img
              src="./imgs/2-4.png"
              :style="{transform: block2Num>=2000?'scale(1,1)':'scale(1.2,1.2)'}"
            />
          </div>
          <div class="text">全国唯一药械鉴核规则库</div>
        </div>
      </div>
      <img class="bg-2" src="./imgs/bg-2.png" />
    </div>
    <div class="block-3">
      <div class="g-block-title">
        <p class="name">鉴核逻辑</p>
        <p class="line"></p>
        <p class="en-name">AUTHENTICATION LOGIC</p>
      </div>
      <div
        class="block-text"
      >以药械追溯码鉴核数据为核心，辅之以身份识别、购销调存、支付、位置、影像等数据，通过循证方式（通过鉴核规则库计算数据内在的逻辑合理性）记录药械销售和使用中人、财、物的数据信息，进而判断医保支付的合规性。</div>
      <div class="block-3-list">
        <div class="item">
          <img src="./imgs/人.png" />
        </div>
        <div class="item">
          <img src="./imgs/财.png" />
        </div>
        <div class="item">
          <img src="./imgs/物.png" />
        </div>
      </div>
    </div>
    <div class="block-4">
      <div class="g-block-title">
        <p class="name">完整闭环</p>
        <p class="line"></p>
        <p class="en-name">COMPLETE CLOSED LOOP</p>
      </div>
      <div class="block-4-list">
        <div class="item" v-for="(item,index) in block4List" :key="index">
          <div class="g-circle-wrap">
            <div class="circle">
              <img :src="item.icon" />
            </div>
          </div>

          <div class="arrow" v-if="index!=block4List.length-1">
            <img src="./imgs/3-7.png" />
          </div>
          <div class="text">{{item.text}}</div>
        </div>
      </div>
    </div>
    <div class="block-5">
      <div class="g-block-title light">
        <p class="name">治理行为</p>
        <p class="line"></p>
        <p class="en-name">GOVERNANCE BEHAVIOR</p>
      </div>
      <div class="block-5-list">
        <div class="item" v-for="(item,index) in block5List" :key="index">
          <img :src="item.img" />
          <p class="text" v-html="item.text"></p>
        </div>
      </div>
    </div>
    <div class="block-6">
      <div class="g-block-title">
        <p class="name">应用场景</p>
        <p class="line"></p>
        <p class="en-name">APPLICATION SCENARIO</p>
      </div>
      <div class="block-6-line">
        <div class="fang" :style="{background: block6Active==0?'#ffffff':'#1061b6'}"></div>
        <div
          class="left"
          :style="{'background-color': block6Active===0?'#1061b6':'#ffffff', color: block6Active===0?'#ffffff':'#1061b6'}"
          @mouseover="block6Active=0"
        >医保两定机构药品购销管理</div>
        <div
          class="right"
          :style="{'background-color': block6Active===1?'#1061b6':'#ffffff', color: block6Active===1?'#ffffff':'#1061b6'}"
          @mouseover="block6Active=1"
        >
          <p>互联网+医保下的药事服务</p>
          <p>（例如网络处方+线下购药/慢特病送药服务等）</p>
        </div>
      </div>
      <transition name="fade" mode="out-in">
        <div class="block-6-img g-clear-float" v-if="block6Active===0" key="left">
          <img src="./imgs/6-1.png" />
          <img src="./imgs/6-2.jpg" />
        </div>
        <div class="block-6-img g-clear-float" v-else key="right">
          <img src="./imgs/6-3.jpg" />
          <img src="./imgs/6-4.jpg" />
        </div>
      </transition>
    </div>
    <div class="block-7">
      <div class="g-block-title light">
        <p class="name">多方受益</p>
        <p class="line"></p>
        <p class="en-name">MULTI BENEFIT</p>
      </div>
      <div class="block-7-list">
        <div class="item" v-for="(item,index) in block7List" :key="index">
          <div class="circle">
            <img :src="item.icon" />
          </div>
          <div class="name">{{item.name}}</div>
          <div class="text">{{item.text}}</div>
        </div>
      </div>
    </div>
    <g-footer></g-footer>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    let _this = this;
    return {
      bannerShow: true,
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observer: true,
        observeParents: true,
        autoplay: {
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: false
        },
        loop: true
      },
      block4List: [
        {
          text: "数据采集",
          icon: require("./imgs/3-1.png")
        },
        {
          text: "规则计算",
          icon: require("./imgs/3-2.png")
        },
        {
          text: "单据预警",
          icon: require("./imgs/3-3.png")
        },
        {
          text: "数据举证",
          icon: require("./imgs/3-6.png")
        },
        {
          text: "处罚申诉",
          icon: require("./imgs/3-5.png")
        },
        {
          text: "支付扣减",
          icon: require("./imgs/3-4.png")
        }
      ],
      block5List: [
        {
          text: "虚构医药服务<br/>伪造购药凭证",
          img: require("./imgs/5-1.jpg")
        },
        {
          text: "串换药品/耗材",
          img: require("./imgs/5-2.png")
        },
        {
          text: "套取/倒卖<br/>医保药品/耗材",
          img: require("./imgs/5-3.png")
        }
      ],
      block7List: [
        {
          name: "医保管理与经办机构",
          text: "降低医保基金风险，提升医保服务能力。",
          icon: require("./imgs/7-1.png")
        },
        {
          name: "药品/医疗/健康服务机构",
          text: "规范服务行为,创新服务模式,提升服务能力,降低服务成本。",
          icon: require("./imgs/7-2.png")
        },
        {
          name: "参保人",
          text: "享受便捷与安全的医保药事服务，参与社会监管。",
          icon: require("./imgs/7-3.png")
        }
      ],
      block6Active: 0,
      block2TopHeight: 0,
      block2Num: 0,
      block2Action: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      document.getElementById("app").scrollTop = 0;
      this.initAnimator();
      document
        .getElementById("app")
        .addEventListener("scroll", this.scrollMethod);
      // 一下操作是为了兼容360兼容模式下，banner图第一次加载图片宽度没有全屏
      setTimeout(() => {
        this.bannerShow = false;
        this.$nextTick(() => {
          this.bannerShow = true;
        });
      }, 500);

    });
  },
  beforeDestroy() {
    document
      .getElementById("app")
      .removeEventListener("scroll", this.scrollMethod);
  },
  methods: {
    initAnimator() {
      // 获取banner图和第一个模块高度，当鼠标滑动到第二模块时开启动画
      let h1 = document.querySelector(".swiper-container").offsetHeight;
      let h2 = document.querySelector(".block-1").offsetHeight;
      this.block2TopHeight = h1 + h2 - 200
    },
    scrollMethod(e) {
      if (e.target.scrollTop >= this.block2TopHeight && !this.block2Action) {
        this.block2Action = true;
        // 开启block2动画
        this.animator();
      }
    },
    animator() {
      this.block2Num = 0;
      let timer = setInterval(() => {
        if (this.block2Num >= 3000) {
          clearInterval(timer);
        } else {
          this.block2Num += 100;
        }
      }, 50);
    }
  }
};
</script>
<style lang="stylus" scoped>
.wrap {
  margin-top: 60px;

  .swiper-container {
    .swiper-slide {
      width: 100%;
    }

    img {
      width: 100%;
    }
  }

  .block-text {
    font-size: 24px;
    width: 60%;
    max-width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    text-indent: 2em;
    text-align: justify;
    line-height: 42px;
  }

  .block-1 {
    .bg {
      display: block;
      margin-top: 40px;
    }
  }

  .block-2 {
    position: relative;
    background-image: linear-gradient(
      90deg,
      #0d0d32 0%,
      #143573 50%,
      #0d0d32 100%
    ), linear-gradient(
      #230808,
      #230808
    );
    -ms-filter: "progid:DXImageTransform.Microsoft.Gradient(startColorStr='#0d0d32',endColorStr='#143573',gradientType='0')";
    padding-bottom: 100px;

    .block-2-list {
      width: 1200px;
      margin: 0 auto;
      font-size: 0;

      .box {
        display: inline-block;
        vertical-align: top;
        width: 33.333%;

        &:nth-child(1) {
          .circle {
            text-align: center;
            font-family: FZHZGBJW--GB1-0;
            font-size: 52px;
            color: #ffffff;
            font-weight: bold;
            line-height: 180px;

            span {
              display: inline-block;
              font-weight: normal;
              margin-left: -15px;
            }
          }
        }

        &:nth-child(2) {
          .circle {
            position: relative;
            transition: all 0.5s;

            &:hover {
              transform: scale(1.1, 1.1) !important
            }

            .small-circle {
              display: inline-block;
              width: 70px;
              height: 70px;
              background-color: #ffffff;
              border-radius: 50%;
              text-align: center;
              line-height: 70px;
              position: absolute;

              &:nth-child(1) {
                left: 50%;
                top: -35px;
                transform: translateX(-50%);
              }

              &:nth-child(2) {
                left: -25px;
                top: 70%;
                transform: translateY(-50%);
              }

              &:nth-child(3) {
                right: -25px;
                top: 70%;
                transform: translateY(-50%);
              }

              img {
                display: inline-block;
                vertical-align: middle;
              }
            }
          }
        }

        &:nth-child(3) {
          .circle {
            font-size: 0;
            text-align: center;
            line-height: 196px;

            img {
              display: inline-block;
              vertical-align: middle;
              transform: scale(1.2, 1.2);
              transition: all 0.5s;
            }
          }
        }

        .circle {
          width: 196px;
          height: 196px;
          border: 5px solid #ffffff;
          border-radius: 50%;
          margin: 0 auto;
          box-sizing: border-box;
          transition: all 0.5s;
          position relative
          z-index 5

          &:hover {
            transform: scale(1.1, 1.1);
          }
        }

        .text {
          font-size: 22px;
          color: #ffffff;
          text-align: center;
          width: 308px;
          margin: 60px auto 0;
        }
      }
    }

    .bg-2 {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      opacity .6
    }
  }

  .block-3 {
    .block-3-list {
      width: 624px;
      margin: 80px auto 0;
      font-size: 0;

      .item {
        display: inline-block;
        vertical-align: top;
        position: relative;
        margin-right: 57px;
        text-align: center;
        width: 170px;
        height: 170px;
        line-height: 170px;
        background-image: linear-gradient(
          135deg,
          #7ebcf9 0%,
          #5d9ff1 34%,
          #3b81e9 100%
        ), linear-gradient(
          #3b81e9,
          #3b81e9
        );
        border-radius: 10px;
        -ms-filter: "progid:DXImageTransform.Microsoft.Gradient(startColorStr='#7ebcf9',endColorStr='#3b81e9',gradientType='0')";

        &:nth-child(3) {
          margin-right: 0;
        }

        &:hover {
          img {
            transform: scale(1.1, 1.1);
          }
        }

        img {
          vertical-align: middle;
          display: inline-block;
          transition: all 0.5s;
        }

        &::after {
          position: absolute;
          left: 50%;
          top: 180px;
          transform: translateX(-50%);
          font-size: 24px;
          line-height: 1;
        }

        &:nth-child(1)::after {
          content: '人';
        }

        &:nth-child(2)::after {
          content: '财';
        }

        &:nth-child(3)::after {
          content: '物';
        }
      }
    }
  }

  .block-4 {
    padding-bottom: 100px;

    .block-4-list {
      width: 1200px;
      margin: 0 auto;
      font-size: 0;

      .item {
        display: inline-block;
        vertical-align: top;

        .g-circle-wrap {
          display: inline-block;
          vertical-align: middle;
          transition: all 0.5s;

          &:hover {
            transform: scale(1.2, 1.2);
          }
        }

        .circle {
          width: 100px;
          height: 100px;
          display: inline-block;
          vertical-align: middle;
          line-height: 100px;
          text-align: center;
          position: relative;
          background-image: linear-gradient(
            135deg,
            #7ebcf9 0%,
            #5d9ff1 34%,
            #3b81e9 100%
          ), linear-gradient(
            #ffffff,
            #ffffff
          );
          -ms-filter: "progid:DXImageTransform.Microsoft.Gradient(startColorStr='#7ebcf9',endColorStr='#3b81e9',gradientType='0')";

          img {
            display: inline-block;
            vertical-align: middle;
          }
        }

        .arrow {
          margin: 0 35px;
          display: inline-block;
          vertical-align: middle;
        }

        .text {
          margin-top: 45px;
          font-size: 24px;
          color: #666666;
        }
      }
    }
  }

  .block-5 {
    padding-bottom: 100px;
    background: url('./imgs/bg-5.png') no-repeat rgba(14, 59, 123, 0.8);
    background-size: 100% 100%;

    .block-5-list {
      width: 1190px;
      margin: 0 auto;
      font-size: 0;

      .item {
        display: inline-block;
        vertical-align: top;
        background-color: #ffffff;
        border-radius: 10px;
        overflow: hidden;
        margin-right: 115px;
        padding-bottom: 135px;
        position: relative;
        transition: all 0.5s;

        &:hover {
          transform: scale(1.1, 1.1);
          box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
        }

        &:nth-child(3) {
          margin-right: 0;
        }

        img {
          width: 100%;
        }

        .text {
          font-size: 24px;
          text-align: center;
          position: absolute;
          top: 330px;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .block-6 {
    padding-bottom: 100px;

    .block-6-line {
      width: 1190px;
      margin: 0 auto;
      font-size: 0;
      border: solid 2px #1061b6;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      cursor: default;

      .fang {
        content: '';
        width: 120px;
        height: 120px;
        background-color: #ffffff;
        position: absolute;
        left: 50%;
        top: 25px;
        transform: translateX(-50%) rotate(45deg);
        transition: all 0.5s;
      }

      .left, .right {
        width: 50%;
        height: 80px;
        display: inline-block;
        vertical-align: top;
        text-align: center;
        font-size: 26px;
        transition: all 0.5s;
      }

      .left {
        line-height: 80px;
      }

      .right {
        p {
          line-height: 1;
          margin-top: 14px;

          &:nth-child(2) {
            margin-top: 11px;
            font-size: 18px;
          }
        }
      }
    }

    .block-6-img {
      width: 1190px;
      margin: 70px auto 0;

      img {
        float: left;
        height: 370px;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1, 1.1);
          box-shadow: 0 0 5px rgba(0, 0, 0, 0.8);
        }

        &:nth-child(2) {
          float: right;
        }
      }
    }
  }

  .block-7 {
    position: relative;
    padding-bottom: 100px;
    background-size: 100% 100%;
    background: url('./imgs/bg-7.jpg') no-repeat;
    background-size: 100% 100%;

    .block-7-list {
      width: 1190px;
      margin: 0 auto;
      font-size: 0;
      position: relative;
      z-index: 2;

      .item {
        display: inline-block;
        vertical-align: top;
        padding: 30px 30px 0;
        width: 330px;
        height: 300px;
        box-sizing: border-box;
        border-radius: 10px;
        border: solid 1px #ffffff;
        margin-right: 100px;
        color: #ffffff;
        transition: all 0.5s;

        &:hover {
          transform: scale(1.1, 1.1);
          box-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
        }

        &:nth-child(3) {
          margin-right: 0;
        }

        .circle {
          width: 65px;
          height: 65px;
          background-color: #ffffff;
          border-radius: 50%;
          text-align: center;
          line-height: 65px;
          margin: 0 auto;

          img {
            display: inline-block;
            vertical-align: middle;
          }
        }

        .name {
          font-size: 24px;
          text-align: center;
          white-space: nowrap;
          line-height: 1;
          padding: 28px 0 25px;
          border-bottom: 1px solid #ffffff;
        }

        .text {
          font-size: 20px;
          text-align: justify;
          line-height: 35px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue